import * as React from 'react';
import * as styles from './styles.css';
import { InlineText1 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import { ICardProps } from '../../types';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { CheckMark } from '../CheckMark';

export const Card: React.FC<ICardProps> = props => {
  const { selected, value, label, imageUrl, iconType, onClick, selectable } = props;

  const deviceType = useDeviceType();
  const handleClick = React.useCallback(() => onClick(value), [onClick, value]);

  return (
    <div
      className={cn(styles['card'], {
        [styles['card_mobile']]: deviceType === 'phone',
        [styles['card_icon']]: iconType === 'icon',
        [styles['card_pic']]: iconType === 'pictures',
      })}
      style={{
        backgroundImage: `url('${imageUrl}')`,
      }}
      onClick={handleClick}
      data-testid="card"
    >
      <InlineText1>{label}</InlineText1>
      {selectable && (
        <div className={styles['checkmark']}>
          <CheckMark checked={!!selected} />
        </div>
      )}
    </div>
  );
};

Card.displayName = 'Card';
